import * as filestack from 'filestack-js'
import config from '@/config'

const filestackClient = filestack.init(config.filestack.apiKey)

export default filestackClient

export const cleanFileName = (fileName) => {
  return fileName.trim()
    .replace(/ /g, '_') // replace whitespace with underscore
    .replace(/[^\w\s]/gi, '_') // remove special characters
    .replace(/_+/g, '_') // combine multiple underscores to one underscore
    .replace(/^_|_$/g, '')
}
